// JsFromRoutes CacheKey e16b61b2f52336f4207434398799424a
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  update: /* #__PURE__ */ definePathHelper('patch', '/order/confirmation/:order_number/:buyer_token/profile'),
}
